import React from 'react';
import { Settings } from 'lucide-react';

const GovernanceLoader = ({ message = "Synchronizing business rules..." }) => {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-slate-50 relative overflow-hidden">
      {/* Subtle Background Decorative Blobs */}
      <div className="absolute top-[-10%] left-[-10%] w-72 h-72 bg-indigo-100 rounded-full blur-3xl opacity-50 animate-pulse" />
      <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50 animate-pulse" />

      <div className="relative z-10 flex flex-col items-center">
        {/* Pulsing Icon Container */}
        <div className="relative mb-8">
          <div className="absolute inset-0 rounded-2xl bg-indigo-500 blur-xl opacity-20 animate-ping" />
          <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-indigo-600 shadow-2xl shadow-indigo-200">
            <Settings className="h-10 w-10 text-white animate-[spin_3s_linear_infinite]" />
          </div>
        </div>

        {/* Text Content */}
        <div className="text-center">
          <h2 className="text-xl font-bold text-slate-800 tracking-tight">
            Data Governance Layer
          </h2>
          <div className="mt-2 flex items-center justify-center gap-2">
            <span className="flex h-1.5 w-1.5 rounded-full bg-indigo-500 animate-bounce [animation-delay:-0.3s]" />
            <span className="flex h-1.5 w-1.5 rounded-full bg-indigo-500 animate-bounce [animation-delay:-0.15s]" />
            <span className="flex h-1.5 w-1.5 rounded-full bg-indigo-500 animate-bounce" />
            <p className="text-sm font-medium text-slate-500 ml-1">
              {message}
            </p>
          </div>
        </div>

        {/* Indeterminate Progress Bar */}
        <div className="mt-8 w-48 h-1.5 bg-slate-200 rounded-full overflow-hidden">
          <div 
            className="h-full bg-indigo-600 rounded-full animate-[loading_2s_ease-in-out_infinite]"
            style={{
              width: '100%',
              maskImage: 'linear-gradient(to right, transparent, black, transparent)',
            }}
          />
        </div>
      </div>

      {/* Global CSS for the custom loading bar animation */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes loading {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}} />
    </div>
  );
};

export default GovernanceLoader;